import { AppDispatch } from "@Reducers/index";
import axiosWrapper from "@AxiosWrapper";

import { setPortalProfilesAction as setPortalProfiles, setCustomModulesAction } from "../reducers/portalSetting";

export function getPortalCustomModules() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.api.post("/portal/customModuleController", {});
    if (responseData.data.status) {
      dispatch(setCustomModulesAction(responseData.data.result));
    }
  };
}

export function getPortalProfiles() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.api.post("/portal/getPortalProfiles", {});
    if (responseData.data.status) {
      dispatch(setPortalProfiles(responseData.data.result));
    }
  };
}
